import Env from '../base/env';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
import Component from 'gia/Component';
import easesCustom from '../fx/CustomEases';
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.container = this.DOM.view.parentElement
    this.DOM.separator = this.DOM.view.querySelector('.fxSeparator')
    this.DOM.items = this.DOM.view.querySelectorAll('.fxItem')
    //
    setTimeout(() => {
      // this.makeSticky()
      this._fx()
    }, Env.timingDelayFx);
  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline()
    this.animation.add([
      gsap.fromTo(
        this.DOM.separator,
        {
          transformOrigin:'left top',
          scaleX:0
        },
        {
          scaleX:1,
          ease:easesCustom.quart,
          duration:.7
        }
      ),
      gsap.fromTo(
        this.DOM.items,
        {
          y:100
        },
        {
          y:.1,
          ease:easesCustom.quart,
          duration:.7,
          stagger:.08
        }
      )
    ])
  }

  makeSticky()
  {
    this.sticky = ScrollTrigger.create({
      trigger:this.DOM.container,
      start:'top top',
      end:'bottom center',
      pin:this.DOM.view,
      pinSpacing:false,
      onEnter:()=>{
        Env.$html.classList.add('filter--isVisible')
      },
      onEnterBack:()=>{
        Env.$html.classList.add('filter--isVisible')
      },
      onLeave:()=>{
        Env.$html.classList.remove('filter--isVisible')
      },
      onLeaveBack:()=>{
        Env.$html.classList.remove('filter--isVisible')
      },
      end: () => {
        const coords = this.DOM.container.getBoundingClientRect()
        return coords.height + coords.y
      },
      invalidateOnRefresh: true
    })
  }

  reveal()
  {
    const offsetStart = (Env.mobileCSS)?'top 80%':'top 70%';
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:offsetStart
    })
  }

  unmount()
  {
    if(typeof this.sticky != 'undefined') {
      this.sticky.kill()
    }

    this.st.kill()
  }
}
